var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"sine","mode":"out-in"}},[_c('div',{staticClass:"sine-container"},_vm._l((100),function(n,index){return _c('div',{key:index,staticClass:"sine-wrapper"},[_c('div',{class:("dot dot-" + n)})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }